export default {
	data() {
		return {}
	},
	props: ['params'],
	methods: {},
	computed:{},
	watch: {},
	components: {}
}